import { Injectable } from '@angular/core';
import * as I from '@interfaces';
import { 
	EnvironmentService,
	ErrorService,
	FuncServiceBase,
	SpinnerService,
	UrlService,
	UtilityService,
} from '@eforall/common';

//
//  This class is generated by generate-client-shims.mjs which is called
//  during the build. DON'T CHANGE IT MANUALLY.
//

@Injectable({ providedIn: 'root' })
export class FuncService extends FuncServiceBase {

	constructor(
		env: EnvironmentService,
		errorService: ErrorService,
		spinner: SpinnerService,
		url: UrlService,
		util: UtilityService,
) {
		super(env, errorService, spinner, url, util);
	}

	public message = {
		setActionTakenUtc: this._call<{ messageId: number }, { messages: I.MessageData[], remainingMessagesCount: number, }>('message.setActionTakenUtc', { noPageSpinner: false, label: 'UPDATING' }),
	};

	public software = {
		setPinnedOrder: this._call<{ softwareId: number }, I.SoftwareData[]>('software.setPinnedOrder', { noPageSpinner: false, label: 'UPDATING' }),
	};

	public getAllData = this._callNoPayload<I.FuncData>('getAllData');
	public getAllMessages = this._callNoPayload<{ messages: I.MessageData[], remainingMessagesCount: number, }>('getAllMessages');
}